export const TEMP_ASSET_STEM = 'breeds';
export const ASSETS_FOLDER_NAME = 'assets';

export const SCRIPTS_FOLDER_NAME = `${TEMP_ASSET_STEM}/${ASSETS_FOLDER_NAME}/scripts`;
export const STYLES_FOLDER_NAME = `${TEMP_ASSET_STEM}/${ASSETS_FOLDER_NAME}/styles`;
export const FONTS_FOLDER_NAME = `${TEMP_ASSET_STEM}/${ASSETS_FOLDER_NAME}/fonts`;
export const IMAGES_FOLDER_NAME = `${TEMP_ASSET_STEM}/${ASSETS_FOLDER_NAME}/images`;
export const FAVICONS_FOLDER_NAME = `${TEMP_ASSET_STEM}/${ASSETS_FOLDER_NAME}/favicons`;
export const DATA_FOLDER_NAME = `${TEMP_ASSET_STEM}/${ASSETS_FOLDER_NAME}/data`;

export const SCRIPTS_URL = `/${SCRIPTS_FOLDER_NAME}`;
export const STYLES_URL = `/${STYLES_FOLDER_NAME}`;
export const FONTS_URL = `/${FONTS_FOLDER_NAME}`;
export const IMAGES_URL = `/${IMAGES_FOLDER_NAME}`;
export const FAVICONS_URL = `/${FAVICONS_FOLDER_NAME}`;
export const DATA_URL = `/${DATA_FOLDER_NAME}`;

export const DATA_MANIFEST_URL = `/${DATA_FOLDER_NAME}/manifest.json`;
